import { Button, Group, LoadingOverlay } from '@mantine/core';

import { Declaration, DeclarationGoods } from '@e-origin/shared';

import { useDeclarant } from '@hooks/declarant';
import { DeclarationViewGoodHVGlobal } from './DeclarationViewGoodHVGlobal';
import { DeclarationViewGoodHVTaxes } from './DeclarationViewGoodHVTaxes';
import { useDeclarationViewGoodHVForm } from './useDeclarationViewGoodHVForm';

interface DeclarationViewGoodHVProps {
  editDisabled?: boolean;
  declaration: Declaration;
  goodDetails: DeclarationGoods;
  onHide(): void;
}

export const DeclarationViewGoodHV: React.FC<DeclarationViewGoodHVProps> = ({ declaration, goodDetails, onHide, editDisabled }) => {
  const { form, onSubmit, handleTax100, handleTaricSupplementaryUnits, handleSupplementaryTotalQuantity, isSaving } = useDeclarationViewGoodHVForm({
    declaration,
    goodDetails,
    onHide,
  });

  const { data: declarant, isLoading } = useDeclarant();

  if (!declarant) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <DeclarationViewGoodHVGlobal form={form} goodDetails={goodDetails} declaration={declaration} editDisabled={editDisabled} />

      <DeclarationViewGoodHVTaxes
        form={form}
        goodDetails={goodDetails}
        declaration={declaration}
        editDisabled={editDisabled}
        handleTax100={handleTax100}
        handleTaricSupplementaryUnits={handleTaricSupplementaryUnits}
        handleSupplementaryTotalQuantity={handleSupplementaryTotalQuantity}
      />

      {!editDisabled && (
        <Group justify="center" my="md">
          <Button loading={isSaving} data-pw="submit-btn" type="submit" key="save-modal-btn" variant="filled" size="lg">
            Save
          </Button>
        </Group>
      )}
    </form>
  );
};
